import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AllDashboardServiceProxy, DashboardMyTimesheetDto } from '../../../../../shared/service-proxies/service-proxies';
import { TimesheetObsService } from '../../../time-sheet/services/timesheet-obs.service';
import { TimesheetService } from '../../../time-sheet/services/timesheet.service';
import * as _ from 'lodash';
import { TimesheetUtilityService } from '@app/main/time-sheet/services/timesheet-utility.service';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { AbpSessionService } from 'abp-ng2-module';

@Component({
  selector: 'app-dashboard-timesheet',
  templateUrl: './dashboard-timesheet.component.html',
  styleUrls: ['./dashboard-timesheet.component.css']
})
export class DashboardTimesheetComponent implements OnInit {
    //Array for Timesheet Records
    isLoaded = false;
    isTimesheetRecordsEmpty = true;
    dateTime = new Date();
    msg:string;
    myDashboardDetails: DashboardMyTimesheetDto[];
    constructor(private _abpSessionService: AbpSessionService,
        private _monitorService:MonitoringService,private _AllDashboardServiceProxy: AllDashboardServiceProxy, private router: Router, injector: Injector, 
        private timesheetobsservice: TimesheetObsService,
        public _tus: TimesheetUtilityService,) { }

    ngOnInit(): void {
        this.msg="userId = "+this._abpSessionService.userId +"tenantId ="+this._abpSessionService.tenantId;
        this._monitorService.logPageView("UI-DashboardTimeSheet");
        this.getUserTimesheetdetails();
  }

  async getUserTimesheetdetails() {
    try{
    this._monitorService.logTrace("UI-getUserTimesheetdetails",{"getUserTimesheetdetails ":"MyTimeSheet: called "+this+this.dateTime})
      await this._AllDashboardServiceProxy.myTimesheet().subscribe(result => {
          this.myDashboardDetails = [];
             result.forEach(x => {            
                if (x.projectImage === '') {
                    x.projectImage = 'assets/common/images/projects/default image for project -1.png';
                }
              this.myDashboardDetails.push(x);

                this.isTimesheetRecordsEmpty = false;
             });
          this.isLoaded = true;
        });
    }
    catch(ex:any){
        this._monitorService.logException(ex ,2);
      }
    }

    viewall() {
        this.router.navigate(['app/main/time-sheet-new/time-sheet-management-new'], { queryParams: { activeTab: 2 } });
    }
    DisableTooltip(name: string, num: number) {
        return name?.length > num ? false : true;
    }
    getHrsAndMinutes(timestamp: string) {
        if (!timestamp) return '00h 00m';
        let hours = Math.floor(parseInt(timestamp.split(":")[0]));
        let min = parseInt(timestamp.split(":")[1]);
        return `${hours < 10 ? "0" + hours : hours}:${min < 10 ? "0" + min : min} h`;
    }


  
}
